import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button, DropdownMenu } from "@skydio/rivet-ui";

export interface DeviceActionsItem {
  key: string;
  onSelectHandler: () => void;
  content: React.ReactNode;
}

export interface DeviceActionsProps {
  items: DeviceActionsItem[];
}

export const DeviceActions = ({ items }: DeviceActionsProps) => {
  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button isIconOnly variant="light">
          <FontAwesomeIcon icon={faEllipsisVertical} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        {items.map(item => (
          <DropdownMenu.Item key={item.key} onSelect={item.onSelectHandler}>
            {item.content}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
